module.exports = __webpack_public_path__ + "img/content-1.1c21ef0e.png";